// extracted by mini-css-extract-plugin
module.exports = {"root":"LoggedInFooterMenu_mobiworkx_root__MCBMz"};